import React from 'react';

function QuoteCard({ quote, author, authenticity, language }) {
  const isLTR = ['en', 'fr'].includes(language);

  return (
    <div className={`quote-card ${isLTR ? 'english-text-card' : ''}`} style={{ direction: isLTR ? 'ltr' : 'rtl' }}>
      <blockquote className="quote-text">{quote}</blockquote>
      <footer className={`quote-footer ${isLTR ? 'quote-footer-english' : ''}`}>
        <span className="quote-author">{author}</span>
        {authenticity && <span className="quote-authenticity"> – {authenticity}</span>}
      </footer>
    </div>
  );
}

export default QuoteCard;
